import React from 'react';

import Heading from 'Components/Heading/Heading';
import Summary from 'Components/Summary/Summary';
import projectManagement from '../../Assets/elvotaimages/projectManagement.png';
import risk from '../../Assets/elvotaimages/risk.png';
import accounting from '../../Assets/elvotaimages/accounting.png';
import profile from '../../Assets/elvotaimages/profile.png';

export default function AdvisoryServices() {
  const content = [
    'At Evolta Technologies, our impact goes beyond trading – our internal tools, powered by AI and market intelligence will support you at every stage of your energy storage journey, from development to operation. We provide comprehensive financial planning and data-driven insights to ensure your BESS projects are financially viable and profitable.'
  ];
  return (
    <div>
      <Heading content="Consulting services" />
      <div className="pb-[40px]">
        <Summary paragraph={content} />
      </div>
      <div className="shadow-lg rounded-[30px] overflow-hidden relative">
        {' '}
        {/* Outer card with rounded corners */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-0 relative bg-white">
          {' '}
          {/* Single column on small screens, 4 columns on medium and larger */}
          {/* Section 1 */}
          <div className="flex flex-col items-center justify-center pt-8 pb-12 px-5">
            {' '}
            {/* No rounded corners */}
            <img
              src={accounting}
              alt="Icon 1"
              className="w-16 h-16 mb-8"
            />{' '}
            {/* 64x64 image with bottom margin */}
            <h2 className="card-content-heading2 uppercase text-center mb-8">
              COMPREHENSIVE FINANCIAL PLANNING
            </h2>{' '}
            {/* Bottom margin for heading */}
            <p className="card-content2 text-center">
            Our data-driven approach provides precise financial projections, ensuring your project is financially sound and poised for long-term success.
            </p>
          </div>
          {/* Section 2 */}
          <div className="flex flex-col items-center justify-center pt-8 pb-12 px-5">
            {' '}
            {/* No rounded corners */}
            <img src={profile} alt="Icon 2" className="w-16 h-16 mb-8" />{' '}
            {/* 64x64 image with bottom margin */}
            <h2 className="card-content-heading2 uppercase text-center mb-8">
            DETAILED REVENUE PROFILING
            </h2>{' '}
            {/* Bottom margin for heading */}
            <p className="card-content2 text-center">
            We create detailed revenue profiles using advanced algorithms, helping you maximize the potential earnings from your BESS operations.
            </p>
          </div>
          {/* Section 3 */}
          <div className="flex flex-col items-center justify-center pt-8 pb-12 px-5">
            {' '}
            {/* No rounded corners */}
            <img src={risk} alt="Icon 3" className="w-16 h-16 mb-8" />{' '}
            {/* 64x64 image with bottom margin */}
            <h2 className="card-content-heading2 uppercase text-center mb-8">
              LONG-TERM RISK MANAGEMENT
            </h2>{' '}
            {/* Bottom margin for heading */}
            <p className="card-content2 text-center">
              Our robust models assess and mitigate long-term risks, giving you peace of mind and a solid foundation for sustainable growth in the energy market.
            </p>
          </div>
          {/* Section 4 */}
          <div className="flex flex-col items-center justify-center pt-8 pb-12 px-5">
            {' '}
            {/* No rounded corners */}
            <img
              src={projectManagement}
              alt="Icon 4"
              className="w-16 h-16 mb-8"
            />{' '}
            {/* 64x64 image with bottom margin */}
            <h2 className="card-content-heading2 uppercase text-center mb-8">
              STRATEGIC PROJECT DEVELOPMENT
            </h2>{' '}
            {/* Bottom margin for heading */}
            <p className="card-content2 text-center">
              We guide you through every step of your BESS project, ensuring your project is optimized for maximum efficiency and profitability.
            </p>
          </div>
          {/* Vertical Dividers - Only on medium screens and larger */}
          <div className="hidden md:block absolute inset-y-0 left-1/4 w-[2px] bg-[#114036] z-10 h-[75%] top-1/2 transform -translate-y-1/2" />{' '}
          {/* Divider 1 */}
          <div className="hidden md:block absolute inset-y-0 left-2/4 w-[2px] bg-[#114036] z-10 h-[75%] top-1/2 transform -translate-y-1/2" />{' '}
          {/* Divider 2 */}
          <div className="hidden md:block absolute inset-y-0 right-1/4 w-[2px] bg-[#114036] z-10 h-[75%] top-1/2 transform -translate-y-1/2" />{' '}
          {/* Divider 3 */}
        </div>
      </div>
    </div>
  );
}
